import type { TranslationTree } from '../../types';

export const settings: TranslationTree = {
  globalSettings: {
    personalSpace: 'Espace personnel',
    title: 'Paramètres',
    description: "Ajustez l'expérience ToolLife et accédez à vos raccourcis favoris.",
    personalizationTitle: 'Personnalisation',
    personalizationDescription:
      'Choisissez le thème qui convient le mieux à votre environnement de travail.',
    quickNavigation: 'Navigation rapide',
    noShortcut: 'Aucun raccourci disponible pour le moment.',
    securityReminder:
      'Pour protéger vos données, pensez à vous déconnecter lorsque vous quittez votre poste de travail.',
    logoutCta: 'Se déconnecter',
    shortcuts: {
      adminTitle: 'Administration',
      adminDescription: 'Gérez les comptes, modules et droits au sein de votre organisation.',
      toolsTitle: 'Navigation outils',
      toolsDescription: 'Accédez à la hiérarchie et ouvrez la fiche détaillée de chaque outil.',
      profileTitle: 'Profil utilisateur',
      profileDescription: 'Modifiez vos informations personnelles et vos préférences.',
    },
  },
};
